/* BB combos — el carrusel de combinaciones marco + cristal (24-sep).
 *
 * Qué hace, y nada más:
 *   1. Al tocar una tarjeta, marca los DOS radios reales de las opciones del
 *      producto (el del marco y el del cristal, los que ya existen en los
 *      fieldsets originales) y dispara `change` en cada uno. De ahí en adelante
 *      manda el theme: `theme.Variants` recalcula la variante, cambia el precio,
 *      la galería, el `?variant=` de la URL y avisa con `variant:change`, que es
 *      lo que escuchan la barra fija y el módulo del 2.º par. No se toca el
 *      formulario ni se reimplementa nada de eso.
 *
 *   2. Si la variante cambia por otro camino (la URL, los radios originales en
 *      un navegador sin `:has()`, el historial), la tarjeta marcada se sincroniza
 *      escuchando `variant:change`.
 *
 * POR QUÉ SE MARCAN LOS DOS ANTES DE DISPARAR: `_onSelectChange` del theme lee
 * el estado ACTUAL de todos los radios para buscar la variante. Si se disparara
 * el `change` del marco con el cristal todavía en el valor viejo, el theme
 * elegiría otra variante y de paso reescribiría el radio del cristal. Primero se
 * deja el estado completo y recién ahí se avisa; el segundo `change` llega sobre
 * un estado que ya cuadra y no mueve nada.
 */
(function () {
  'use strict';
  if (window.__bbCombos) return;
  window.__bbCombos = true;

  function init() {
    var fs = document.querySelector('[data-bb-combos]');
    if (!fs) return;

    var ambito = fs.closest('[data-bb-ficha-v2]') || document;
    var idxMarco = fs.getAttribute('data-marco-index') || 'option1';
    var idxCristal = fs.getAttribute('data-cristal-index') || 'option2';

    /* El radio real de una opción con ese valor. Se excluyen los propios
       (no llevan data-index, pero el guardia deja la intención escrita). */
    function radioReal(indice, valor) {
      var lista = ambito.querySelectorAll('input[type="radio"][data-index="' + indice + '"]');
      for (var i = 0; i < lista.length; i++) {
        if (!lista[i].hasAttribute('data-bb-combo') && lista[i].value === valor) return lista[i];
      }
      return null;
    }

    function aplicar(radio) {
      var a = radioReal(idxMarco, radio.getAttribute('data-opt1'));
      var b = radioReal(idxCristal, radio.getAttribute('data-opt2'));
      if (!a || !b) return;
      a.checked = true;
      b.checked = true;
      a.dispatchEvent(new Event('change', { bubbles: true }));
      b.dispatchEvent(new Event('change', { bubbles: true }));
    }

    fs.addEventListener('change', function (ev) {
      var r = ev.target;
      if (!r || r.name !== 'bb-combo') return;
      aplicar(r);
    });

    /* Sincronizar la tarjeta cuando la variante cambia por otro camino. No se
       dispara ningún `change` acá: marcar el radio por programa no reentra en
       el escuchador de arriba, así que no hay vuelta infinita. */
    document.addEventListener('variant:change', function (ev) {
      var v = ev.detail && ev.detail.variant;
      if (!v) return;
      var r = fs.querySelector('input[data-variant-id="' + v.id + '"]');
      if (!r || r.checked) return;
      r.checked = true;
      if (typeof window.__bbAsomarColor === 'function') window.__bbAsomarColor();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
